// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-body[data-v-864ea4f2]{padding:16px}.color-picker-container[data-v-864ea4f2]{height:30px;display:inline-flex}.color-picker-container .color-picker[data-v-864ea4f2]{cursor:pointer;width:20px;height:20px}.tag-color-show[data-v-864ea4f2]{border:1px solid grey;margin-left:25px;width:20px;height:20px;padding-top:10px}", ""]);
// Exports
module.exports = exports;
